import {httpRequest} from '../config/axios';
import {getAppliedFilters} from '../utils/helper';

export async function getFailedOrders({pageIndex, pageSize, filters}) {
  const {dateQuery, filterQuery} = getAppliedFilters({filters});
  if (!(dateQuery.from && dateQuery.to)) return {rows: [], pageCount: 0};
  const response = await httpRequest.post('/get-failed-orders', {
    date: dateQuery,
    filters: {
      ...filterQuery,
      operationType: ['PLACE_ORDER'],
    },
    page: pageIndex + 1,
    sort: {
      field: 'timestamp',
      type: -1,
    },
    limit: pageSize,
  });

  return {
    rows: response?.data?.data?.data?.list || [],
    totalCount: response?.data?.data?.data?.totalCount || null,
  };
}

export async function getOrderDetails({filters, documentId}) {
  const dateQuery = {from: null, to: null};
  filters?.forEach((filter) => {
    if (filter?.id === 'Date') {
      const [from, to] = filter?.value || [];
      dateQuery.from = from;
      dateQuery.to = to;
    }
  });
  if (!(dateQuery.to && dateQuery.to)) return {orderBody: []};
  const response = await httpRequest.post('/get-order-body', {
    date: dateQuery,
    filters: {
      operationType: ['PLACE_ORDER'],
      documentId,
    },
    page: 1,
    limit: 1,
  });
  return {
    data: response?.data?.data?.data || {},
  };
}

export async function getFailedOrdersReport({filters}) {
  const dateQuery = {from: null, to: null};
  const filterQuery = {};
  filters?.forEach((filter) => {
    if (filter?.id === 'Date') {
      const [from, to] = filter?.value || [];
      dateQuery.from = from;
      dateQuery.to = to;
    } else if (filter.id === 'Channel') {
      if (Array.isArray(filter?.value) && filter?.value.length > 0) {
        filterQuery.channelCode = [];
        filterQuery.channelGroupCode = [];
        filter?.value?.forEach((channel) => {
          const [channelGroupCode, channelCode] = channel?.split('-') || [];
          filterQuery.channelCode.push(channelCode);
          filterQuery.channelGroupCode.push(channelGroupCode);
        });
      }
    } else if (filter?.isApplied) {
      filterQuery[filter?.key] = filter?.value;
    }
  });
  if (!(dateQuery.to && dateQuery.to)) return {data: {}};
  const response = await httpRequest.post('/failed-orders/report', {
    date: dateQuery,
    filters: {
      operationType: ['PLACE_ORDER'],
      ...filterQuery,
    },
  });
  return {
    data: response?.data?.data?.data || {},
  };
}
